import { render, staticRenderFns } from "./ModalRemoverDaTarja.vue?vue&type=template&id=75d2abe2"
import script from "./ModalRemoverDaTarja.vue?vue&type=script&lang=js"
export * from "./ModalRemoverDaTarja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports